import React, { useState, useEffect } from 'react';

const ContactPage = ({ onNavigate }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to handle navigation
  const handleNavigation = (page) => {
    onNavigate(page);
    setIsMenuOpen(false); // Close mobile menu after navigation
  };

  // Function to handle social media links
  const handleSocialClick = (platform) => {
    const urls = {
      twitter: 'https://twitter.com/your-university',
      facebook: 'https://facebook.com/your-university',
      pinterest: 'https://pinterest.com/your-university',
      linkedin: 'https://linkedin.com/company/your-university'
    };
    window.open(urls[platform], '_blank');
  };

  const contactInfo = [
    {
      icon: '📍',
      title: 'Address',
      details: [
        'Telinipara, Barasat - Barrackpore Rd',
        'Bara Kanthalia, West Bengal - 700121'
      ],
      link: 'https://maps.app.goo.gl/qX5SvAa7uWZaPdxi7',
      color: '#0f766e'
    },
    {
      icon: '📞',
      title: 'Phone Numbers',
      details: [
        '+91 7044086270',
        '+91 7980333922',
        '+91 9830278216'
      ],
      link: 'tel:+917044086270',
      color: '#059669'
    },
    {
      icon: '✉️',
      title: 'Email Addresses',
      details: [
        'info@swamivivekanandauniversity.ac.in',
        'vc@swamivivekanandauniversity.ac.in',
        'registrar@swamivivekanandauniversity.ac.in'
      ],
      link: 'mailto:info@swamivivekanandauniversity.ac.in',
      color: '#0d9488'
    }
  ];

  const departments = [
    { name: 'Admissions Office', email: 'admissions@swamivivekanandauniversity.ac.in', icon: '🎓' },
    { name: 'Academic Office', email: 'academics@swamivivekanandauniversity.ac.in', icon: '📚' },
    { name: 'Student Affairs', email: 'studentaffairs@swamivivekanandauniversity.ac.in', icon: '👥' },
    { name: 'International Office', email: 'international@swamivivekanandauniversity.ac.in', icon: '🌍' },
    { name: 'Career Services', email: 'careers@swamivivekanandauniversity.ac.in', icon: '💼' },
    { name: 'Alumni Relations', email: 'alumni@swamivivekanandauniversity.ac.in', icon: '🤝' }
  ];

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#ffffff',
      overflowX: 'hidden',
      width: '100%'
    }}>
      {/* Header */}
      <header style={{
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 50
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: isMobile ? '0 0.5rem' : '0 1rem'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1rem 0'
          }}>
            {/* Logo */}
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleNavigation('home')}>
              <img
                src="/logo.png"
                alt="Swami Vivekananda University Logo"
                style={{ width: '48px', height: '48px', objectFit: 'contain' }}
              />
              <div style={{ marginLeft: '12px' }}>
                <h1 style={{
                  fontSize: isMobile ? '16px' : '20px',
                  fontWeight: 'bold',
                  color: '#1f2937',
                  margin: 0
                }}>Swami Vivekananda</h1>
                <p style={{
                  fontSize: '14px',
                  color: '#0f766e',
                  margin: 0
                }}>University</p>
              </div>
            </div>

            {/* Desktop Navigation */}
            {!isMobile && (
              <nav style={{
                display: 'flex',
                gap: '2rem'
              }}>
                <button onClick={() => handleNavigation('home')} style={{
                  color: '#374151',
                  fontWeight: '500',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'color 0.3s',
                  position: 'relative',
                  padding: '0.5rem 0',
                  fontSize: '16px'
                }}
                onMouseEnter={(e) => e.target.style.color = '#0f766e'}
                onMouseLeave={(e) => e.target.style.color = '#374151'}>
                  Home
                </button>
                <button onClick={() => handleNavigation('about')} style={{
                  color: '#374151',
                  fontWeight: '500',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'color 0.3s',
                  position: 'relative',
                  padding: '0.5rem 0',
                  fontSize: '16px'
                }}
                onMouseEnter={(e) => e.target.style.color = '#0f766e'}
                onMouseLeave={(e) => e.target.style.color = '#374151'}>
                  About
                </button>
                <a href="#contact-info" style={{
                  color: '#0f766e',
                  fontWeight: '500',
                  textDecoration: 'none',
                  transition: 'color 0.3s',
                  position: 'relative',
                  padding: '0.5rem 0'
                }}
                onMouseEnter={(e) => e.target.style.color = '#059669'}
                onMouseLeave={(e) => e.target.style.color = '#0f766e'}>
                  Contact
                </a>
              </nav>
            )}

            {/* Desktop Login Button */}
            {!isMobile && (
              <button onClick={() => handleNavigation('login')} style={{
                backgroundColor: '#0f766e',
                color: 'white',
                padding: '10px 24px',
                borderRadius: '8px',
                border: 'none',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 4px rgba(15, 118, 110, 0.2)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#0d9488';
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 4px 8px rgba(15, 118, 110, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#0f766e';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 4px rgba(15, 118, 110, 0.2)';
              }}>
                Portal Login
              </button>
            )}

            {/* Mobile Hamburger Menu */}
            {isMobile && (
              <button
                onClick={toggleMenu}
                style={{
                  width: '40px',
                  height: '40px',
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  zIndex: 1001
                }}
              >
                <div style={{
                  width: '25px',
                  height: '3px',
                  backgroundColor: '#374151',
                  borderRadius: '3px',
                  position: 'absolute',
                  top: isMenuOpen ? '50%' : '30%',
                  left: '50%',
                  transform: `translate(-50%, -50%) ${isMenuOpen ? 'rotate(45deg)' : 'rotate(0)'}`,
                  transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
                }}></div>
                <div style={{
                  width: '25px',
                  height: '3px',
                  backgroundColor: '#374151',
                  borderRadius: '3px',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  opacity: isMenuOpen ? 0 : 1,
                  transition: 'all 0.3s ease'
                }}></div>
                <div style={{
                  width: '25px',
                  height: '3px',
                  backgroundColor: '#374151',
                  borderRadius: '3px',
                  position: 'absolute',
                  top: isMenuOpen ? '50%' : '70%',
                  left: '50%',
                  transform: `translate(-50%, -50%) ${isMenuOpen ? 'rotate(-45deg)' : 'rotate(0)'}`,
                  transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
                }}></div>
              </button>
            )}
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobile && (
          <>
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: isMenuOpen ? '20vw' : '0',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              zIndex: 998,
              opacity: isMenuOpen ? 1 : 0,
              visibility: isMenuOpen ? 'visible' : 'hidden',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(3px)'
            }} onClick={toggleMenu}></div>

            <div style={{
              position: 'fixed',
              top: 0,
              right: isMenuOpen ? '0' : '-100%',
              width: '80vw',
              maxWidth: '300px',
              height: '100vh',
              backgroundColor: '#ffffff',
              boxShadow: '-8px 0 32px rgba(0, 0, 0, 0.2)',
              transition: 'right 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
              zIndex: 999,
              padding: '6rem 2rem 2rem 2rem',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
              }}>
                {[
                  { name: 'Home', page: 'home' },
                  { name: 'About', page: 'about' },
                  { name: 'Contact', page: 'contact' }
                ].map((item, index) => (
                  <button
                    key={item.name}
                    onClick={() => handleNavigation(item.page)}
                    style={{
                      color: '#374151',
                      fontWeight: '600',
                      background: 'none',
                      border: 'none',
                      fontSize: '18px',
                      padding: '16px 20px',
                      borderRadius: '12px',
                      transition: 'all 0.3s ease',
                      display: 'block',
                      position: 'relative',
                      transform: isMenuOpen ? 'translateX(0)' : 'translateX(50px)',
                      opacity: isMenuOpen ? 1 : 0,
                      transitionDelay: `${index * 0.1 + 0.2}s`,
                      cursor: 'pointer',
                      textAlign: 'left',
                      width: '100%'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = '#0f766e';
                      e.target.style.backgroundColor = '#f0fdfa';
                      e.target.style.transform = 'translateX(10px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = '#374151';
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.transform = 'translateX(0)';
                    }}
                  >
                    {item.name}
                    <span style={{
                      position: 'absolute',
                      right: '20px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontSize: '20px',
                      opacity: 0.5
                    }}>→</span>
                  </button>
                ))}
                
                {/* Portal Login Button with Green Container */}
                <button
                  onClick={() => handleNavigation('login')}
                  style={{
                    color: 'white',
                    fontWeight: '600',
                    backgroundColor: '#0f766e',
                    border: 'none',
                    fontSize: '18px',
                    padding: '16px 20px',
                    borderRadius: '12px',
                    transition: 'all 0.3s ease',
                    display: 'block',
                    position: 'relative',
                    transform: isMenuOpen ? 'translateX(0)' : 'translateX(50px)',
                    opacity: isMenuOpen ? 1 : 0,
                    transitionDelay: `${3 * 0.1 + 0.2}s`,
                    cursor: 'pointer',
                    textAlign: 'left',
                    width: '100%',
                    boxShadow: '0 4px 12px rgba(15, 118, 110, 0.3)',
                    marginTop: '8px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#0d9488';
                    e.target.style.transform = 'translateX(10px)';
                    e.target.style.boxShadow = '0 6px 16px rgba(15, 118, 110, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#0f766e';
                    e.target.style.transform = 'translateX(0)';
                    e.target.style.boxShadow = '0 4px 12px rgba(15, 118, 110, 0.3)';
                  }}
                >
                  Portal Login
                  <span style={{
                    position: 'absolute',
                    right: '20px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: '20px',
                    opacity: 0.8
                  }}>→</span>
                </button>
              </div>
            </div>
          </>
        )}
      </header>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #f0fdfa 0%, #dcfce7 50%, #e6fffa 100%)',
        padding: isMobile ? '3rem 0' : '6rem 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '200px',
          height: '200px',
          background: 'linear-gradient(45deg, rgba(15, 118, 110, 0.1), rgba(5, 150, 105, 0.1))',
          borderRadius: '50%',
          filter: 'blur(40px)'
        }}></div>
        
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: isMobile ? '0 0.5rem' : '0 1rem',
          position: 'relative'
        }}>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{
              fontSize: isMobile ? '2rem' : '4rem',
              fontWeight: 'bold',
              color: '#1f2937',
              marginBottom: '1.5rem',
              lineHeight: '1.2'
            }}>
              Get in <span style={{ 
                color: '#0f766e',
                background: 'linear-gradient(135deg, #0f766e, #059669)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>Touch</span>
            </h1>
            <p style={{
              fontSize: isMobile ? '1.1rem' : '1.25rem',
              color: '#374151',
              marginBottom: '3rem',
              maxWidth: '800px',
              margin: '0 auto 3rem auto',
              lineHeight: '1.6'
            }}>
              Have questions about admissions, programs, or campus life? We're here to help you take the next step in your educational journey. Connect with us today!
            </p>
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
              gap: '2rem',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  width: isMobile ? '50px' : '60px',
                  height: isMobile ? '50px' : '60px',
                  backgroundColor: '#0f766e',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem auto',
                  boxShadow: '0 4px 12px rgba(15, 118, 110, 0.3)'
                }}>
                  <span style={{ fontSize: isMobile ? '20px' : '24px', color: 'white' }}>📞</span>
                </div>
                <h3 style={{ fontSize: isMobile ? '16px' : '18px', fontWeight: 'bold', color: '#1f2937', marginBottom: '0.5rem' }}>Call Us</h3>
                <p style={{ fontSize: '14px', color: '#6b7280' }}>Speak directly with our team</p>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  width: isMobile ? '50px' : '60px',
                  height: isMobile ? '50px' : '60px',
                  backgroundColor: '#059669',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem auto',
                  boxShadow: '0 4px 12px rgba(5, 150, 105, 0.3)'
                }}>
                  <span style={{ fontSize: isMobile ? '20px' : '24px', color: 'white' }}>✉️</span>
                </div>
                <h3 style={{ fontSize: isMobile ? '16px' : '18px', fontWeight: 'bold', color: '#1f2937', marginBottom: '0.5rem' }}>Email Us</h3>
                <p style={{ fontSize: '14px', color: '#6b7280' }}>Send us your inquiries</p>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  width: isMobile ? '50px' : '60px',
                  height: isMobile ? '50px' : '60px',
                  backgroundColor: '#0d9488',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem auto',
                  boxShadow: '0 4px 12px rgba(13, 148, 136, 0.3)'
                }}>
                  <span style={{ fontSize: isMobile ? '20px' : '24px', color: 'white' }}>📍</span>
                </div>
                <h3 style={{ fontSize: isMobile ? '16px' : '18px', fontWeight: 'bold', color: '#1f2937', marginBottom: '0.5rem' }}>Visit Us</h3>
                <p style={{ fontSize: '14px', color: '#6b7280' }}>Come to our campus</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section id="contact-info" style={{ 
        padding: isMobile ? '3rem 0' : '6rem 0', 
        backgroundColor: '#ffffff' 
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: isMobile ? '0 0.5rem' : '0 1rem'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: isMobile ? '2.5rem' : '3rem',
              fontWeight: 'bold',
              color: '#1f2937',
              marginBottom: '1rem'
            }}>Contact Information</h2>
            <p style={{
              fontSize: isMobile ? '18px' : '20px',
              color: '#6b7280',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Multiple ways to reach us for your convenience. Choose the method that works best for you.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem'
          }}>
            {contactInfo.map((info, index) => (
              <div key={index} style={{
                backgroundColor: '#f8fafc',
                borderRadius: '20px',
                padding: '2.5rem',
                textAlign: 'center',
                border: `2px solid ${info.color}20`,
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = `${info.color}10`;
                e.currentTarget.style.borderColor = info.color;
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = `0 20px 40px ${info.color}20`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f8fafc';
                e.currentTarget.style.borderColor = `${info.color}20`;
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  backgroundColor: info.color,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 2rem auto',
                  boxShadow: `0 8px 20px ${info.color}30`
                }}>
                  <span style={{ fontSize: '36px', color: 'white' }}>{info.icon}</span>
                </div>
                <h3 style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  color: info.color,
                  marginBottom: '1.5rem'
                }}>{info.title}</h3>
                <div style={{ marginBottom: '1.5rem' }}>
                  {info.details.map((detail, detailIndex) => (
                    <p key={detailIndex} style={{
                      color: '#374151',
                      fontSize: '16px',
                      marginBottom: '8px',
                      lineHeight: '1.6'
                    }}>{detail}</p>
                  ))}
                </div>
                <a
                  href={info.link}
                  target={info.link.startsWith('http') ? '_blank' : '_self'}
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    color: info.color,
                    fontWeight: '600',
                    textDecoration: 'none',
                    padding: '12px 24px',
                    backgroundColor: `${info.color}10`,
                    borderRadius: '8px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = info.color;
                    e.target.style.color = 'white';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = `${info.color}10`;
                    e.target.style.color = info.color;
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Contact Now →
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Departments Section */}
      <section id="departments" style={{ 
        padding: isMobile ? '3rem 0' : '6rem 0', 
        backgroundColor: '#f9fafb' 
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: isMobile ? '0 0.5rem' : '0 1rem'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: isMobile ? '2.5rem' : '3rem',
              fontWeight: 'bold',
              color: '#1f2937',
              marginBottom: '1rem'
            }}>Department Contacts</h2>
            <p style={{
              fontSize: isMobile ? '18px' : '20px',
              color: '#6b7280',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Connect directly with specific departments for specialized assistance and information.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '1.5rem',
            maxWidth: '1000px',
            margin: '0 auto'
          }}>
            {departments.map((dept, index) => (
              <div key={index} style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                padding: isMobile ? '1.5rem' : '2rem',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                transition: 'all 0.3s ease',
                border: '1px solid #e5e7eb',
                maxWidth: '100%'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.15)';
                e.currentTarget.style.borderColor = '#0f766e';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
                e.currentTarget.style.borderColor = '#e5e7eb';
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '1rem',
                  flexWrap: 'wrap'
                }}>
                  <div style={{
                    width: isMobile ? '40px' : '50px',
                    height: isMobile ? '40px' : '50px',
                    backgroundColor: '#ccfbf1',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '1rem',
                    flexShrink: 0
                  }}>
                    <span style={{ fontSize: isMobile ? '20px' : '24px' }}>{dept.icon}</span>
                  </div>
                  <h3 style={{
                    fontSize: isMobile ? '16px' : '18px',
                    fontWeight: 'bold',
                    color: '#1f2937',
                    margin: 0,
                    lineHeight: '1.3'
                  }}>{dept.name}</h3>
                </div>
                <a
                  href={`mailto:${dept.email}`}
                  style={{
                    color: '#0f766e',
                    fontSize: isMobile ? '13px' : '14px',
                    textDecoration: 'none',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    transition: 'color 0.3s ease',
                    wordBreak: 'break-all',
                    lineHeight: '1.4'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#059669'}
                  onMouseLeave={(e) => e.target.style.color = '#0f766e'}
                >
                  {dept.email} →
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Location Section */}
      <section id="location" style={{ 
        padding: isMobile ? '3rem 0' : '6rem 0', 
        background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)', 
        color: 'white' 
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: isMobile ? '0 0.5rem' : '0 1rem'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: isMobile ? '3rem' : '4rem',
            alignItems: 'center'
          }}>
            <div>
              <h2 style={{
                fontSize: isMobile ? '2.5rem' : '3rem',
                fontWeight: 'bold',
                marginBottom: '1.5rem'
              }}>Visit Our Campus</h2>
              <p style={{
                fontSize: isMobile ? '18px' : '20px',
                color: '#d1d5db',
                marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                Experience our beautiful 12-acre campus surrounded by greenery and water bodies. Modern facilities including gym, cafeteria, open-air theatre, auditorium, and library await you.
              </p>

              <div style={{ marginBottom: '2rem' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  marginBottom: '1rem',
                  padding: '1rem',
                  borderRadius: '12px',
                  backgroundColor: 'rgba(15, 118, 110, 0.1)',
                  border: '1px solid rgba(94, 234, 212, 0.2)'
                }}>
                  <span style={{ 
                    color: '#5eead4', 
                    marginRight: '16px', 
                    fontSize: '20px',
                    minWidth: '20px'
                  }}>📍</span>
                  <div>
                    <p style={{ color: '#d1d5db', margin: 0, lineHeight: '1.5' }}>
                      Telinipara, Barasat - Barrackpore Rd<br />
                      Bara Kanthalia, West Bengal - 700121
                    </p>
                  </div>
                </div>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                gap: isMobile ? '0.5rem' : '1rem'
              }}>
                <button style={{
                  backgroundColor: '#0f766e',
                  color: 'white',
                  padding: '14px 24px',
                  borderRadius: '12px',
                  border: 'none',
                  fontWeight: '600',
                  fontSize: '16px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onClick={() => window.open('https://maps.app.goo.gl/qX5SvAa7uWZaPdxi7', '_blank')}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#0d9488';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#0f766e';
                  e.target.style.transform = 'translateY(0)';
                }}>
                  Open in Maps
                </button>
                <button style={{
                  border: '2px solid #5eead4',
                  color: '#5eead4',
                  backgroundColor: 'transparent',
                  padding: '14px 24px',
                  borderRadius: '12px',
                  fontWeight: '600',
                  fontSize: '16px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#5eead4';
                  e.target.style.color = '#1f2937';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#5eead4';
                  e.target.style.transform = 'translateY(0)';
                }}>
                  Get Directions
                </button>
              </div>
            </div>

            {/* Map */}
            <div style={{
              backgroundColor: 'rgba(55, 65, 81, 0.5)',
              borderRadius: '20px',
              padding: '1.5rem',
              backdropFilter: 'blur(10px)',
              border: '2px solid rgba(94, 234, 212, 0.2)'
            }}>
              <div style={{
                width: '100%',
                height: '400px',
                borderRadius: '16px',
                overflow: 'hidden'
              }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.0967891234567!2d88.5!3d22.7!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDQyJzAwLjAiTiA4OMKwMzAnMDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Swami Vivekananda University Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ 
        backgroundColor: '#111827', 
        color: '#d1d5db', 
        padding: '3rem 0 2rem 0' 
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: isMobile ? '0 0.5rem' : '0 1rem'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '2rem'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleNavigation('home')}>
              <img
                src="/logo.png"
                alt="SVU Logo"
                style={{ width: '40px', height: '40px', objectFit: 'contain' }}
              />
              <div style={{ marginLeft: '12px' }}>
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: 'white',
                  margin: 0
                }}>Swami Vivekananda</h3>
                <p style={{ fontSize: '14px', margin: 0 }}>University</p>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '1rem' }}>
              {[
                { platform: 'twitter', path: 'M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z' },
                { platform: 'facebook', path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
                { platform: 'linkedin', path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' }
              ].map(social => (
                <button
                  key={social.platform}
                  onClick={() => handleSocialClick(social.platform)}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    border: '1px solid #374151',
                    backgroundColor: 'transparent',
                    color: '#9ca3af',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = '#5eead4';
                    e.target.style.backgroundColor = '#5eead4';
                    e.target.style.color = '#1f2937';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = '#374151';
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#9ca3af';
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d={social.path} />
                  </svg>
                </button>
              ))}
            </div>
          </div>

          <div style={{
            borderTop: '1px solid #374151',
            paddingTop: '2rem',
            marginTop: '2rem',
            textAlign: 'center'
          }}>
            <p style={{ fontSize: '14px', margin: 0, opacity: 0.8 }}>
              &copy; 2025 Swami Vivekananda University. All rights reserved. | UGC Recognized Private University
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;